import Backbone from 'backbone'
import _ from 'lodash'
import icon from 'scoreboard/components/icon'
import Tooltip from 'scoreboard/components/tooltip'
import TooltipAndDetails from './tooltip-and-details'

/**
 * Renders breadcrumbs as seen on the group | org permissions form and
 * when swapping scorecard nodes in a dashboard.
 *
 * Tooltip usage:
 *
 * If objects are known (i.e. from an api call retrieving ancestors)
 * this.breadcrumbsTooltip = Breadcrumbs.tooltip({
 *   target: e.target,
 *   objects: ancestors,
 *   title: i18n.get('common.title') // Optional - default is "Breadcrumb"
 * })
 *
 * If the objects are not known:
 * this.tooltip = Breadcrumbs.tooltip({
 *   target: e.currentTarget,
 *   id: id,
 *   gardener: this.objectSelector.objectGardener
 * })
 *
 */
var Breadcrumbs = Backbone.View.extend({

	// this.options.objects are the domain objects to show in the
	// breadcrumbs

	className: 'breadcrumbs tooltip-body',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		let content = ''
		_.each(this.options.objects, function(object, index) {
			content += '<span class="breadcrumb">' + _.escape(object.label) + '</span>'
			// add arrow icon between each object, but don't put one at the end
			if (index < this.options.objects.length - 1) {
				content += '<div class="breadcrumb-arrow-wrapper">' + icon('collapsed') + '</div>'
			}
		}.bind(this))
		if (!_.isNil(this.options.title)) {
			content =
				'<div class="title">' + this.options.title + '</div>' +
				content
		}

		this.$el.empty().append(content)
		return this
	}

}, {

	tooltip: function(options) {
		var breadcrumbs = this.getBreadcrumbs(options)

		return new Tooltip({
			attachTo: options.target,
			content: breadcrumbs,
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	tooltipAndDetails: function(options, el) {
		var breadcrumbs = this.getBreadcrumbs(options)

		return new TooltipAndDetails({
			selector: options.attachTo,
			attachTo: options.attachTo,
			tooltipContent: () => breadcrumbs,
			tooltipOptions: {
				extraClass: 'breadcrumbs-tooltip',
				setTooltipBodyMaxHeight: true
			},
			el,
		})
	},

	getBreadcrumbs: function(options) {
		var objects = []
		if (options.objects) {
			objects = options.objects
		} else {
			var node = options.gardener.tree.get(options.id)
			// collect all the objects that form the breadcrumbs
			var objects = []
			do {
				objects.push(node)
				if (node.parentId) {
					node = options.gardener.tree.get(node.parentId)
				} else {
					node = null
				}
			}
			while (node)
			objects = _.reverse(objects)
		}

		return new Breadcrumbs({ objects })
	}

})

export default Breadcrumbs

Breadcrumbs.__filename__ = 'components/breadcrumbs.js'
